// Single source of truth for "is this a desktop-class machine with a printer?".
// Thermal slip printing exists ONLY on desktop/PC web: phones and tablets (incl. iPadOS, which
// reports a desktop-like UA and platform "MacIntel") never auto-print and never show a print button.

export function isTabletOrPhone() {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/Android|iPhone|iPod|iPad|Mobile|Silk|Kindle|PlayBook|BB10/i.test(ua)) return true;
  // iPadOS 13+ desktop mode: Mac UA + a real touch screen.
  const touchPoints = navigator.maxTouchPoints || 0;
  if (/Macintosh/i.test(ua) && touchPoints > 1) return true;
  // Any other touch-primary device without a fine pointer (Android tablets, Windows tablets).
  const coarse = window.matchMedia?.("(pointer: coarse)")?.matches;
  const fine = window.matchMedia?.("(any-pointer: fine)")?.matches;
  return !!(touchPoints > 0 && coarse && !fine);
}

/** True only on desktop/PC web, where the print dialog is expected and useful. */
export function canPrintSlips() {
  return typeof window !== "undefined" && !isTabletOrPhone();
}
